import Alpine from 'alpinejs'
import './css/app.scss';

window.Alpine = Alpine

Alpine.start()

console.log('ALPINE!')
